module.exports = "/work-site/img/swing.df759166.png";